// 📁 src/components/account/modules/ScoutModule.jsx

import React, { useEffect, useState } from 'react';

export default function ScoutModule() {
  const [companyName, setCompanyName] = useState('');
  const [tenantId, setTenantId] = useState('');

  useEffect(() => {
    const email = localStorage.getItem('email');
    const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');
    const account = registry[email] || {};
    setCompanyName(account.companyName || '');
    setTenantId(account.tenantId || '');

    const auditLog = JSON.parse(localStorage.getItem(`paymentAuditLog_${email}`) || '[]');
    const accessEntry = auditLog.find((entry) => entry.moduleName === 'Scout');
    const isPaid = accessEntry?.paymentStatus === 'paid' && accessEntry?.status === 'active';

    if (!isPaid) {
      alert('Access to Scout is denied. Please complete payment.');
    }
  }, []);

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold text-indigo-700 mb-2">Scout Module</h2>
      {(companyName || tenantId) && (
        <div className="mb-4 text-sm text-gray-600 italic">
          {companyName && <div>Company Name: {companyName}</div>}
          {tenantId && <div>Tenant ID: {tenantId}</div>}
        </div>
      )}
      <p className="text-gray-600">
        This is a placeholder for the candidate sourcing and outreach automation interface.
      </p>
    </div>
  );
}
